// ** Initial State
const initialState = {
   rawList: [],
   WODump: [],
   loading: false,
   error: '',

   approvedlist:[],
   approvedloading:false,
   approvederror:'',

    wopreviousMonthlist: [],
    wopreviousMonthloading: false,
    wopreviousMontherror: '',


    WO_Status_Data: [],
    WO_Status_loading: false,
    WO_Status_error: ''

}
// ----------------------Raw Approval Screen-----------------------------
const wovalidationReducer = (state = initialState, action) => {
  
  switch (action.type) {
    // RAW WO
    case 'RAWWO_LOADING': {
           return {
               ...state,
               loading: true,
               error:''
           }
       }
       case 'RAWWO_SUCCESS': {
           return {
               ...state,
               rawList: action.data,
               loading: false
           }
       }
       case 'RAWWO_ERROR': {
           return {
               ...state,
               loading: false,
               error: action.error
           }
       }

     // RAW WO page size 100
    case 'Raw_Dump_WorkOrder_Details':
    	return { ...state, WODump: action.data }
       // WO Approved List
    case 'WOApproved_LOADING': {
           return {
               ...state,
               approvedloading: true,
               approvederror:''
           }
       }
       case 'WOApproved_SUCCESS': {
           return {
               ...state,
               approvedlist: action.data,
               approvedloading: false
           }
       }
       case 'WOApproved_ERROR': {
           return {
               ...state,
               approvedloading: false,
               approvederror: action.error
           }
       }


       // WO Get Previous Month
    case 'WOGetPreviousMonth_LOADING': {
           return {
               ...state,
               wopreviousMonthloading: true,
               wopreviousMontherror:''
           }
       }
       case 'WOGetPreviousMonth_SUCCESS': {
           return {
               ...state,
               wopreviousMonthlist: action.data,
               wopreviousMonthloading: false
           }
       }
       case 'WOGetPreviousMonth_ERROR': {
           return {
               ...state,
               wopreviousMonthloading: false,
               wopreviousMontherror: action.error
           }
       }


           // RAW WO update status
    case 'Update_WO_Status_LOADING': {
           return {
               ...state,
               WO_Status_loading: true,
               WO_Status_error:''
           }
       }
       case 'Update_WO_Status_SUCCESS': {
           return {
               ...state,
               WO_Status_Data: action.data,
               WO_Status_loading: false
           }
       }
       case 'Update_WO_Status_ERROR': {
           return {
               ...state,
               WO_Status_loading: false,
               WO_Status_error: action.error
           }
       }
    default:
      return state
  }
}
// ----------------------Raw File Uplaod Screen-----------------------------
export default wovalidationReducer


